<template>
  <svg fill="#3254B9" height="27" width="27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       viewBox="0 0 512 512" xml:space="preserve">
    <g>
      <g>
        <path d="M4.71,0v147.877l178.335,178.335V512l145.91-48.637V326.211L507.29,147.877V0H4.71z M458.653,127.731L280.318,306.066
          v122.243l-48.637,16.212V306.066L53.347,127.731V48.637h405.306V127.731z"/>
      </g>
    </g>
  </svg>
</template>

<script setup>

</script>

<style scoped lang="scss">

</style>
